module.exports = __webpack_public_path__ + "img/info.50c52465.svg";